import React, { Component } from 'react'
import { connect } from 'react-redux'
import ArticleList from 'components/page/ArticleList'
import { actions } from './redux'
import preload from 'components/enhancer/preload'
import composeHOC from 'shared/utils/composeHOC'
import Meta from 'components/layout/Meta';

class AnnouncementList extends Component {

  constructor(props) {
    super(props)
    this.state = {}
  }
  componentDidMount(){

  }

  setPage(page) {
    //this.props.router.push('/aboutUs/news/'+page)
    this.props.getAnnouncementList(page).then((result) => {
      this.setState({
        announcementList: result.data.items,
        announcementPagination: {
          currentPage: Number(result.data.page),
          total: Number(result.data.total),
          perPage: Number(result.data.pagesize)
        }
      })
    })
  }

  render() {
    let {
      announcementList,
      announcementPagination
    } = this.state

    if (!announcementList) {
      announcementList = this.props.announcementList
      announcementPagination = this.props.announcementPagination
    }

    const {
      getAnnouncementList,
      setPage,
      children
    } = this.props


    return (
      <div>
        <Meta location={this.props.location} title="公司公告-关于我们"/>
        {announcementList && <ArticleList
          title="公司公告"
          subtitle="ANNOUNCEMENT"
          setPage={this.setPage.bind(this)}
          linkPrefix="/aboutUs/announcementDetail/"
          pagination={announcementPagination}
          items={announcementList}
        />}
      </div>
    )
  }
}



export default composeHOC(
  connect(state => ({
    announcementList: state.aboutUs.announcementList,
    announcementPagination: state.aboutUs.announcementPagination
  }), actions),
  preload(({dispatch, location}) => {
    //const id = location.pathname.substr( location.pathname.lastIndexOf('/') + 1 )
    return Promise.all([
      dispatch(actions.getAnnouncementList(1))
    ])
  })
)(AnnouncementList)



// WEBPACK FOOTER //
// ./modules/aboutUs/AnnouncementList.js